// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSelection.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import ColorPalette from './Izenda.ColorPalette';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import { chunk } from 'lodash/fp';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import actions from './Izenda.ColorPaletteSelectionActions';
import connect from 'share/enhancers/Izenda.Connect';
import { SelectableContext, createSelectable } from 'share/components/hoc/Izenda.Selectable';

const selectableContext = new SelectableContext();
const SelectableColorPalette = createSelectable(ColorPalette, selectableContext);

export default connect(actions)(function ColorPaletteSelection(props) {
  const { localization, title, palettes, selectedPaletteName } = props;
  const Cols = 3;
  const smallCols = 6;

  const renderRows = palettes => {
    return palettes.map((item, index) => (
      <GridLayout.Col
        cols={Cols}
        xs={smallCols}
        className="u_noPaddingLeft izenda-ColorPaletteSelection-Col"
        key={`${index}`}
      >
        <SelectableColorPalette
          model={item}
          isDefaultTheme={item.isDefaultTheme}
          displaySettingStatus={props.displaySettingStatus}
          selected={selectedPaletteName === item.name}
          onClick={props.onSelectColorPalette.bind(null, item)}
        />
      </GridLayout.Col>
    ));
  };

  return (
    <Popup visible onClosing={props.onClosing} autoClose={false} type="none" sizeClass="modal-lg">
      <Popup.Header title={title} />
      <Popup.Body>
        <div className="izenda-ColorPaletteSelection">
          <ScrollBox>
            <GridLayout>{renderRows(palettes)}</GridLayout>
          </ScrollBox>
        </div>
      </Popup.Body>
      <Popup.Footer>
        <Popup.ConfirmationButton type="accept">{localization.getText('COMMON_LABEL_OK')}</Popup.ConfirmationButton>
        <Popup.ConfirmationButton type="cancel">{localization.getText('COMMON_LABEL_CANCEL')}</Popup.ConfirmationButton>
      </Popup.Footer>
    </Popup>
  );
});



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorPalette/Izenda.ColorPaletteSelection.js